import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import caciLogoWhite from '../images/cacilogoWhite.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookSquare,
  faSquareXTwitter,
  faLinkedin,
  faYoutubeSquare,
  faInstagramSquare,
} from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

export default function Footer() {
  return (
    <Container fluid style={{ padding: 0 }}>
      <div className='footer'>
        <Container>
          {/* Row containing logo and contact info */}
          <Row className='h-100'>
            {/* Logo */}
            <Col lg={2} className='align-items-center' style={{display: 'flex'}}>
              <img
                className="footerLogo"
                src={caciLogoWhite}
                alt="CACI Logo"
                onClick={() => window.open('https://www.caci.com', '_blank')}
              />
            </Col>
            {/* Contact info and social media */}
            <Col lg={6} className='mt-3 mt-lg-0'>
              <Row className='text-start h-100'>
                {/* Contact Info */}
                <Col lg={4}>
                  <p>
                    <strong>Corporate Headquarters</strong><br/>
                    CACI International Inc<br/> 
                    12021 Sunset Hills Road<br/>
                    Reston, VA 20190<br/>
                    (703) 841-7800
                  </p>
                </Col>
                {/* Social Media Links */}
                <Col lg={6}>
                  <p>
                    <strong>Find career opportunities at:</strong><br/>
                    <a href="https://careers.caci.com/global/en" target="_blank" rel="noopener noreferrer">careers.caci.com</a>
                  </p>
                  <p>
                    <strong>Connect with us through social media:</strong><br/>
                    <a className="socialLink" href="https://www.facebook.com/CACIIntl/" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
                    </a>&nbsp;
                    <a className="socialLink" href="https://twitter.com/CACIIntl" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faSquareXTwitter} size="2x" />
                    </a>&nbsp;
                    <a className="socialLink" href="https://www.linkedin.com/company/caci-international-inc/" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faLinkedin} size="2x" />
                    </a>&nbsp;
                    <a className="socialLink" href="https://www.youtube.com/user/CACIInternational" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faYoutubeSquare} size="2x" />
                    </a>&nbsp;
                    <a className="socialLink" href="https://www.instagram.com/caciintl/" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faInstagramSquare} size="2x" />
                    </a>
                  </p>
                  <p><a target="_blank" rel="noopener noreferrer" href='https://caci-dam.widen.net/s/7nxjmlsdtd/fy25_crr_report'>Download PDF</a></p>
                </Col>
              </Row>
            </Col>
            {/* Disclaimer Note */}
            <Col lg={4}>
              <p className='footerNote'>This report outlines activities, data, and initiatives from Fiscal Year (FY) 2024, in alignment with SASB standards for Software and IT Services. Public financial filings — including our annual report and proxy filings — can be found at <a href="https://www.caci.com/" target="_blank" rel="noopener noreferrer">caci.com</a>, as well as on the Security and Exchange Commission’s website at <a href="https://www.sec.gov/" target="_blank" rel="noopener noreferrer">sec.gov</a>.</p>
              <p className='footerNote'>CACI did not seek assurance for this report.</p>
              <p className='footerNote'>We welcome feedback on our ESG initiatives and reporting. Please submit any comments or questions to <a href="mailto:ESG@caci.com">ESG@caci.com</a>.</p>
            </Col>
          </Row>
          <Row>
          	<Col>
          		<p className='footerNote'>CACI and CACI Ever Vigilant are registered trademarks of CACI. <br/>©2026 CACI International Inc. All rights reserved.</p>
          	</Col>
          </Row>
        </Container>
      </div>
    </Container>
  );
}